export default __webpack_public_path__ + "static/ebook_web_lp2-dce83a60519c34519d13abc07b95d0fb.webp";